(() => {
  'use strict';

  const RUNTIME_KEY = '__gdcCartClarityRuntime';
  const runtime = window[RUNTIME_KEY];
  if (runtime?.bound) return;

  window[RUNTIME_KEY] = {
    bound: true,
    timer: null,
    observer: null,
    cartUpdateUnsubscriber: null,
  };

  const isZh = () => String(document.documentElement.lang || '').toLowerCase().startsWith('zh');
  const country = () => document.getElementById('GdcFreeGiftConfig')?.dataset?.country || '';

  const localizeRecoveryCopy = () => {
    const recovery = document.querySelector('.gdc-cart-recovery');
    if (!recovery) return;
    const zh = isZh();
    const message = recovery.querySelector('.gdc-cart-recovery__message');
    const viewCart = recovery.querySelector('.gdc-cart-recovery__actions .button--secondary');
    const checkout = recovery.querySelector('.gdc-cart-recovery__checkout');
    if (message) message.textContent = zh ? '已加入購物車。' : 'Item added to cart.';
    if (viewCart) viewCart.textContent = zh ? '查看購物車' : 'View cart';
    if (checkout) checkout.textContent = zh ? '結帳' : 'Checkout';
  };

  const render = () => {
    localizeRecoveryCopy();
    const footer = document.querySelector('cart-drawer .cart-drawer__footer');
    if (!footer) return;

    let box = footer.querySelector('[data-gdc-cart-clarity]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'gdc-cart-clarity';
      box.dataset.gdcCartClarity = '';
      box.style.cssText =
        'margin:.6rem 0 .9rem;padding:0;color:rgba(var(--color-foreground),.7);font-size:1.15rem;line-height:1.4;';
      const totals = footer.querySelector('.totals');
      const ctas = footer.querySelector('.cart__ctas');
      if (totals) totals.before(box);
      else if (ctas) ctas.before(box);
      else footer.append(box);
    }

    const zh = isZh();
    const overseas = country() && country() !== 'HK';
    const html = zh
      ? (overseas ? '<p style="margin:0">海外運費於結帳時按地區計算。</p>' : '') +
        '<p style="margin:.25rem 0 0">香港設計 · 尺寸指南 / 更換政策 · 支援指定海外地區配送</p>'
      : (overseas ? '<p style="margin:0">Shipping to supported international destinations is calculated at checkout.</p>' : '') +
        '<p style="margin:.25rem 0 0">Designed in Hong Kong · Size guide / exchange policy · International delivery to selected destinations</p>';

    if (box.dataset.gdcCartClarityHtml === html) return;
    box.innerHTML = html;
    box.dataset.gdcCartClarityHtml = html;
  };

  const schedule = () => {
    clearTimeout(window[RUNTIME_KEY].timer);
    window[RUNTIME_KEY].timer = setTimeout(render, 80);
  };

  const isRelevantCartMutation = (mutation) => {
    const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
    if (!target?.closest?.('cart-drawer')) return false;
    if (target.closest('[data-gdc-cart-clarity], [data-gdc-free-gift-ui]')) return false;
    return true;
  };

  const bindCartUpdateEvents = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    window[RUNTIME_KEY].cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  };

  const boot = () => {
    render();

    const drawer = document.querySelector('cart-drawer');
    const observeTarget = drawer || document.body;
    window[RUNTIME_KEY].observer = new MutationObserver((mutations) => {
      if (mutations.some(isRelevantCartMutation)) schedule();
    });
    window[RUNTIME_KEY].observer.observe(observeTarget, { childList: true, subtree: true });

    bindCartUpdateEvents();
    window.addEventListener('pageshow', schedule);
    document.addEventListener('gdc:cart-state-changed', schedule);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();